export enum InputType {
  Password = 'password',
  Text = 'text'
}
